/** * * Asynchronously loads the component for
Home Phone
* */ import { lazyLoad } from "utils/loadable";
export const HomePhone = lazyLoad(
  () => import("./index"),
  (module) => module.HomePhone
);
